import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

class Coordenacao extends Component {
  render() {
    return (
      <React.Fragment>
        <Grid container style={{ backgroundColor: '#5dc8ae', paddingBottom: '1rem', paddingTop: '1rem' }} justify="center">
          <Grid item xs={10}>
            <Typography variant="h3" style={{ textAlign: 'center', color: 'white', paddingBottom: '1rem', paddingTop: '1rem' }}>
              Coordenação
            </Typography>
            <Grid container spacing={32}>
              <Grid item xs={12} sm={6} lg={3}>
                <div style={{ border: '1px solid #fff', borderRadius: '.25rem', paddingBottom: '1rem', paddingTop: '1rem' }}>
                  <Typography variant="h4" style={{ textAlign: 'center', color: '#fff' }}>
                    Presidente
                  </Typography>
                  <Typography variant="subtitle1" style={{ textAlign: 'center', color: '#fff' }}>
                    Rafael Doering Soares
                  </Typography>
                  <Typography variant="subtitle2" style={{ textAlign: 'center', color: '#fff' }}>
                    rafael.doering.soares@usp.br
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} lg={3}>
                <div style={{ border: '1px solid #fff', borderRadius: '.25rem', paddingBottom: '1rem', paddingTop: '1rem' }}>
                  <Typography variant="h4" style={{ textAlign: 'center', color: '#fff' }}>
                    Marketing
                  </Typography>
                  <Typography variant="subtitle1" style={{ textAlign: 'center', color: '#fff' }}>
                    Carolina Arenas Okawa
                  </Typography>
                  <Typography variant="subtitle2" style={{ textAlign: 'center', color: '#fff' }}>
                    carolina.arenas@usp.br
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} lg={3}>
                <div style={{ border: '1px solid #fff', borderRadius: '.25rem', paddingBottom: '1rem', paddingTop: '1rem' }}>
                  <Typography variant="h4" style={{ textAlign: 'center', color: '#fff' }}>
                    Educação
                  </Typography>
                  <Typography variant="subtitle1" style={{ textAlign: 'center', color: '#fff' }}>
                    Orlando Pasqual Filho
                  </Typography>
                  <Typography variant="subtitle2" style={{ textAlign: 'center', color: '#fff' }}>
                    or.pasqual@gmail.com
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} lg={3}>
                <div style={{ border: '1px solid #fff', borderRadius: '.25rem', paddingBottom: '1rem', paddingTop: '1rem' }}>
                  <Typography variant="h4" style={{ textAlign: 'center', color: '#fff' }}>
                    Infraestrutura
                  </Typography>
                  <Typography variant="subtitle1" style={{ textAlign: 'center', color: '#fff' }}>
                    Marcos Wendell Souza
                  </Typography>
                  <Typography variant="subtitle2" style={{ textAlign: 'center', color: '#fff' }}>
                    marcos.wendell.santos@usp.br
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default Coordenacao;